import clsx from 'clsx';
import { observer } from 'mobx-react';
import { Tooltip } from 'react-tooltip';
import { T } from '../../../../../../Translations';
import LearningCollectionEditStore from '../../../Edit/Store';
import NewBrowseAllSectionButton from './NewBrowseAllSectionButton';

interface Props {
  store: LearningCollectionEditStore;
  close: () => void;
}

function NewSectionPopup({ store, close }: Props) {
  return (
    <Tooltip
      id="add-section-button"
      place="bottom"
      className={clsx('bg-white max-w-xl border border-gray-300 rounded-md shadow px-4 py-5')}
      isOpen
      clickable
      variant="light"
      classNameArrow="hidden"
    >
      <ul>
        <li className="mb-4" data-intercom-target="builder-start-with-blank-section">
          <button
            onClick={() => {
              store.createByoLearningDesign();
              close();
            }}
            className="w-full text-left"
          >
            <div className="font-bold">
              <T kind="Start with a blank section" />
            </div>
            <div>
              <T kind="Pick your own programs and build from scratch" />
            </div>
          </button>
        </li>
        <li data-intercom-target="builder-start-with-curated-sections">
          <button onClick={store.choosingLearningDesigns} className="w-full text-left">
            <div className="font-bold">
              <T kind="Start with Curated Sections" />
            </div>
            <div>
              <T kind="Choose from an extensive library of themes..." />
            </div>
          </button>
        </li>
        <NewBrowseAllSectionButton store={store} />
      </ul>
    </Tooltip>
  );
}

export default observer(NewSectionPopup);
